import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionTitle } from './SectionTitle';
import { CTAButton } from './CTAButton';
import { testimonials } from '../data/salesCopy';
export function Testimonials() {
  return <section className="bg-brand-sand px-4 py-8 sm:py-10" data-id="element-196" data-mp="3fycr5ou809bu">
      <div className="mx-auto max-w-4xl" data-id="element-197" data-mp="3b0uf3pkwpdzm">
        <SectionTitle data-id="element-198" data-mp="3azt4tnbpsviy">Ce que disent les professeurs</SectionTitle>

        <ul className="mt-5 grid grid-cols-1 gap-2.5 md:grid-cols-2" data-id="element-199" data-mp="36zimrcaneenq">
          {testimonials.map((t, i) => <li key={t.name} className={`flex h-full flex-col rounded-lg bg-brand-ivory p-3.5 ${i === testimonials.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-200" data-mp="31zmrc1g0nvjs" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 étoiles sur 5" data-id="element-201" data-mp="2s39reltvolgl">
                {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-brand-gold text-brand-gold" aria-hidden="true" data-id="element-202" data-mp="v7c6l6gih5pe" />)}
              </div>
              <p className="mt-2 text-[12.5px] font-medium italic leading-snug text-brand-brown/90 sm:text-[13.5px]" data-id="element-203" data-mp="m4rj1y8p0nzk">
                “{t.quote}”
              </p>
              <div className="mt-auto pt-2.5" data-id="element-204" data-mp="79v7pc5l7ki9">
                <p className="text-[12.5px] font-bold text-brand-brown" data-id="element-205" data-mp="c6234b0cxdly">
                  {t.name}
                </p>
                <p className="text-[11.5px] font-medium text-brand-taupe" data-id="element-206" data-mp="zxr0w6vy6uaa">
                  {t.role} — {t.location}
                </p>
              </div>
            </li>)}
        </ul>

        <div className="mt-5 flex justify-center" data-id="element-207" data-mp="q5v18re7qw3y">
          <CTAButton data-id="element-208" data-mp="v5pqyrm95fnf">🧘 Oui ! Je veux le système complet</CTAButton>
        </div>
      </div>
    </section>;
}